<template>
  <div>
    <portal to="page-top-title">Edit Api #{{ id }}</portal>
    <portal to="page-top-right">
      <btn :route="{ name: 'apis-single', params: { id: id } }" icon="fa-eye" text>Back to Api</btn>
    </portal>

    <box-form action="edit" data-prop="formData" redirect="apis-list" :url="`/apis/${id}`" :loaded="loaded" loader>
      <template slot="content">
        <row>
          <column-input>
            <form-group-input name="name" :model="formData.name" :min="3" required/>
          </column-input>
          <column-input>
            <form-group-input type="number" name="sending_rate" :model="formData.sending_rate" :min="0" required/>
          </column-input>
          <column-input :md="2">
            <form-group-check name="active" :model="formData.active"/>
          </column-input>
        </row>
        <row>
          <column-input :sm="12" :md="12" v-if="!credsLoaded">
            <btn type="button" color="warning" ref="loadCredsBtn" @click.native.prevent="loadCreds" flat text>Load Credentials</btn>
          </column-input>
          <column-input :sm="12" :md="12" v-else>
            <form-group-multi-input name="credentials" :model="formData.credentials" required/>
          </column-input>
        </row>
      </template>
    </box-form>
  </div>
</template>

<script>
import BoxForm from '@/views/components/data/BoxForm'
import Btn from '@/views/components/simple/Btn'
import FormGroupInput from '@/views/components/form/FormGroupInput'
import FormGroupCheck from '@/views/components/form/FormGroupCheck'
import FormGroupMultiInput from '@/views/components/form/FormGroupMultiInput'
import Form from '@/modules/utils/Form'

export default {
  name: 'ApisEdit',
  metaInfo () {
    return { title: `Api #${this.id} | Edit` }
  },
  components: {
    BoxForm,
    Btn,
    FormGroupInput,
    FormGroupCheck,
    FormGroupMultiInput
  },
  computed: {
    id () { return this.$route.params.id }
  },
  data () {
    return {
      loaded: false,
      credsLoaded: false,
      formData: {
        name: Form.types.input(),
        sending_rate: Form.types.number(),
        active: Form.types.boolean(),
        credentials: Form.types.multiInput()
      }
    }
  },
  created () {
    this.loadEntity()
    this.formData.credentials.hidden = true
  },
  methods: {
    loadEntity () {
      this.$http
        .get(`/apis/${this.id}`)
        .then((res) => {
          const { data: { data } } = res

          this.formData.name.value = data.name
          this.formData.active.value = data.active
          this.formData.sending_rate.value = data.sending_rate

          this.loaded = true
        })
    },
    loadCreds () {
      this.$refs.loadCredsBtn.$el.setAttribute('disabled', 'disabled')

      this.$http
        .get(`/apis/${this.id}/credentials`)
        .then((res) => {
          const creds = []
          const { data: { data } } = res

          for (const key in (data || {})) {
            creds.push({ key: key, value: Form.types.input(data[key]) })
          }

          if (creds.length) {
            this.formData.credentials = Form.types.multiInput(creds)
            this.credsLoaded = true
          }
        })
        .finally(() => {
          this.$refs.loadCredsBtn.$el.removeAttribute('disabled')
        })
    }
  }
}
</script>
